import { useCallback, useContext } from "react"

import { useLocalSearchParams } from "expo-router"

import {
  AccountCollection,
  AccountData,
  ClientCollection,
  DepositoryTransaction,
  DepositoryTransactionCollection,
} from "wealthmode-frontend/backend"
import { Box, HStack } from "wealthmode-frontend/gluestack/ui"
import { formatMoneyFull } from "wealthmode-frontend/util"

import { DataTable, IDLink } from "@/components"
import { BackendContext } from "@/context"

export default function DepositoryTransactions() {
  const { client_id, account_id } = useLocalSearchParams<{
    client_id: string
    account_id: string
  }>()

  const backend = useContext(BackendContext)

  const load = useCallback(async () => {
    const clients = backend.collection("clients") as ClientCollection
    const client = clients.model(client_id)
    await client.fetch({ reload: true })

    const accounts = client.link("accounts")?.resolve() as AccountCollection
    const account = accounts.model(account_id)
    await account.fetch({ reload: true })

    const data = account.embed("data") as AccountData
    const transactions = data.link("depository_transactions")?.resolve() as DepositoryTransactionCollection | undefined
    if (!transactions) {
      return undefined
    }

    await transactions.fetch({ reload: true })

    return transactions
  }, [backend, client_id, account_id])

  return (
    <Box>
      <HStack>
        <Box className="flex-1">
          <DataTable
            title={"Depository Transactions"}
            load={load}
            header={[
              { id: "id", title: "ID", shrink: true },
              { id: "date", title: "Date" },
              { id: "type", title: "Type" },
              { id: "description", title: "Description" },
              { id: "amount", title: "Amount" },
            ]}
            render={(model: DepositoryTransaction, field: string) => {
              switch (field) {
                case "id":
                  return (
                    <IDLink
                      href={`/clients/${client_id}/accounts/${account_id}/depository_transactions/${model.attributes.id}`}
                      id={model.attributes.id}
                    />
                  )

                case "amount":
                  return formatMoneyFull(model.get(field))
              }
              return model.get(field)
            }}
          />
        </Box>
      </HStack>
    </Box>
  )
}
